<template>
	<div class="center_right">
		<div class="center_commNav">
			<div class="center_commNavItem" @click="activeName=item.id" :class="{'active':activeName==item.id}" v-for="(item,index) in commNavs">{{item.name}}</div>
		</div>
		<div v-show="activeName=='1'">
			<div class="center_filter">
				<div class="center_filterInput">
					<el-form :inline="true" label-width="100px">
						<el-form-item label="课程名称：">
							<el-input v-model="finiOnname" placeholder="请输入课程名称" clearable></el-input>
						</el-form-item>
						<el-form-item label="课程类型：">
							<el-select :popper-append-to-body='false' v-model="finiOntypeId" placeholder="请选择课程类型" clearable>
								<el-option :label="item.name" :value="item.id" v-for='(item,index) in typeList'></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="授课老师：">
							<el-input v-model="finiOnuserName" placeholder="请输入授课老师" clearable></el-input>
						</el-form-item>
						<el-form-item>
							<div class="center_filterBtns">
								<el-button @click="finiOnCurrentChange(1)" type='primary'>搜索</el-button>
								<el-button @click='clearfiniOnFilter'>重置</el-button>
							</div>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<div class="center_tables center_labtables">
				<el-table :data="finiOnlistData" ref='centerfiniOnTable' border stripe>
					<emptymain slot='empty' :emptylist='finiOnlistData'></emptymain>
					<el-table-column label="课程信息" width='450' align='center'>
						<template slot-scope="scope">
							<div class="center_courseBox pointer" @click="toCourseindex(scope.row)">
								<div class="center_courseinfo">
									<img :src="baseurl + scope.row.banner" />
								</div>
								<div class="center_courseTitle text-ellipsis">{{scope.row.courseName}}</div>
								<div class="center_courseDesc text-ellipsis"><i class="el-icon-s-order"></i>{{scope.row.typeName || '-'}}</div>
								<div class="center_courseDesc text-ellipsis"><i class="el-icon-s-custom"></i>{{scope.row.teacherName}}</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="当前在学" prop="sectionName" align='center'>
						<template slot-scope="scope">
							{{scope.row.sectionName || '无'}}
						</template>
					</el-table-column>
					<el-table-column label="总学习进度" width='185' align='center'>
						<template slot-scope="scope">
							<div class="center_courseCtatus">
								<el-progress :percentage="scope.row.progress?parseInt(scope.row.progress): 0" :stroke-width='10'></el-progress>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" align='center'>
						<template slot-scope="scope">
							<el-button plain size='medium' @click='toCourseindex(scope.row)'>继续学习</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="all_current">
				<el-pagination prev-text='上一页' next-text='下一页' background @current-change="finiOnCurrentChange" :current-page="finiOncurrent" :page-size="limit" layout="total,  prev, pager, next" :total="finiOntotal">
				</el-pagination>
			</div>
		</div>
		<div v-show="activeName=='2'">
			<div class="center_filter">
				<div class="center_filterInput">
					<el-form :inline="true" label-width="100px">
						<el-form-item label="课程名称：">
							<el-input v-model="finiOffname" placeholder="请输入课程名称" clearable></el-input>
						</el-form-item>
						<el-form-item label="课程类型：">
							<el-select :popper-append-to-body='false' v-model="finiOfftypeId" placeholder="请选择课程类型" clearable>
								<el-option :label="item.name" :value="item.id" v-for='(item,index) in typeList'></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="授课老师：">
							<el-input v-model="finiOffuserName" placeholder="请输入授课老师" clearable></el-input>
						</el-form-item>
						<el-form-item>
							<div class="center_filterBtns">
								<el-button @click="finiOffCurrentChange(1)" type='primary'>搜索</el-button>
								<el-button @click='clearfiniOffFilter'>重置</el-button>
							</div>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<div class="center_tables center_labtables">
				<el-table :data="finiOfflistData" ref='centerfiniOffTable' border stripe>
					<emptymain slot='empty' :emptylist='finiOfflistData'></emptymain>
					<el-table-column label="课程信息" width='450' align='center'>
						<template slot-scope="scope">
							<div class="center_courseBox pointer" @click="toCourseindex(scope.row)">
								<div class="center_courseinfo">
									<img :src="baseurl + scope.row.banner" />
								</div>
								<div class="center_courseTitle text-ellipsis">{{scope.row.courseName}}</div>
								<div class="center_courseDesc text-ellipsis"><i class="el-icon-s-order"></i>{{scope.row.typeName || '-'}}</div>
								<div class="center_courseDesc text-ellipsis"><i class="el-icon-s-custom"></i>{{scope.row.teacherName}}</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="当前在学" prop="sectionName" align='center'>
						<template slot-scope="scope">
							{{scope.row.sectionName || '无'}}
						</template>
					</el-table-column>
					<el-table-column label="总学习进度" width='185' align='center'>
						<template slot-scope="scope">
							<div class="center_courseCtatus">
								<el-progress :percentage="scope.row.progress?parseInt(scope.row.progress): 0" status='success' :stroke-width='10'></el-progress>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" align='center'>
						<template slot-scope="scope">
							<el-button plain size='medium' @click='toCourseindex(scope.row)'>重新学习</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="all_current">
				<el-pagination prev-text='上一页' next-text='下一页' background @current-change="finiOffCurrentChange" :current-page="finiOffcurrent" :page-size="limit" layout="total,  prev, pager, next" :total="finiOfftotal">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import { listMajorByPid } from '@/api/major'
	import { getUnCourseProgressList, getCourseProgressList } from '@/api/course.js'
	export default {
		data() {
			return {
				activeName: '1',
				commNavs: [{
					name: '进行中的课程',
					id: '1'
				}, {
					name: '已完成的课程',
					id: '2'
				}],
				limit: 10,
				typeList: [],
				//进行中的课程
				finiOnname: '',
				finiOnuserName: '',
				finiOntypeId: '',
				finiOnlistData: [],
				finiOncurrent: 1,
				finiOntotal: 0,
				//已完成的课程
				finiOffname: '',
				finiOffuserName: '',
				finiOfftypeId: '',
				finiOfflistData: [],
				finiOffcurrent: 1,
				finiOfftotal: 0,
			};
		},
		created() {
			this.getTypeList();
			this.getfiniOnListData();
			this.getfiniOffListData();
		},
		methods: {
			clearfiniOnFilter() {
				this.finiOnname = '';
				this.finiOntypeId = '';
				this.finiOnuserName = '';
				this.finiOncurrent = 1
				this.getfiniOnListData();
			},
			finiOnCurrentChange(finiOncurrent) {
				this.finiOncurrent = finiOncurrent;
				this.getfiniOnListData();
			},
			getfiniOnListData() {
				var data = {
					teacherName: this.finiOnuserName ? this.finiOnuserName : null,
					courseName: this.finiOnname ? this.finiOnname : null,
					typeId: this.finiOntypeId ? this.finiOntypeId : null,
					current: this.finiOncurrent,
					limit: this.limit,
				}
				getUnCourseProgressList(data).then(res => {
					if(res.code == "OK") {
						this.finiOnlistData = res.data.records;
						this.finiOntotal = res.data.total;
					}
				})
			},
			clearfiniOffFilter() {
				this.finiOffname = '';
				this.finiOfftypeId = '';
				this.finiOffuserName = '';
				this.finiOffcurrent = 1
				this.getfiniOffListData();
			},
			finiOffCurrentChange(finiOffcurrent) {
				this.finiOffcurrent = finiOffcurrent;
				this.getfiniOffListData();
			},
			getfiniOffListData() {
				var data = {
					teacherName: this.finiOffuserName ? this.finiOffuserName : null,
					courseName: this.finiOffname ? this.finiOffname : null,
					typeId: this.finiOfftypeId ? this.finiOfftypeId : null,
					current: this.finiOffcurrent,
					limit: this.limit,
				}
				getCourseProgressList(data).then(res => {
					if(res.code == "OK") {
						this.finiOfflistData = res.data.records;
						this.finiOfftotal = res.data.total;
					}
				})
			},
			getTypeList() {
				listMajorByPid({
					pid: this.majorIdForAll
				}).then(res => {
					this.typeList = res.data;
				})
			},
			toCourseindex(item) {
				this.$router.push({
					name: 'coursedetail',
					query: {
						courseId: item.courseId
					}
				})
			},
		}
	}
</script>